import { accosBarData } from '@/store/accosbar.store'
import dayjs from 'dayjs'
import { Title, type IGuestDataStore } from './interfaces/appInterfaces'

export function setCookie(cname: string, cvalueasjson: string, exdays: number): void {
  const d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  let expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalueasjson + ';' + expires + ';path=/'
}

export function checkIfCookieExists(cname: string): boolean {
  let name = cname + '='
  let ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) == ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) == 0) {
      return true
    }
  }
  return false
}

export function accosBarDataToGuestDataStoreJsonString(): string {
  var dto: IGuestDataStore = {
    Arrival: accosBarData.value.date ? dayjs(accosBarData.value.date[0]).format('YYYY-MM-DD') : '',
    Departure: accosBarData.value.date ? dayjs(accosBarData.value.date[1]).format('YYYY-MM-DD') : '',
    Rooms: accosBarData.value.rooms?.map((x) => ({
      adults: x.adults || 0,
      children: x.children || 0,
      childrenAges: x.childrenAges || []
    })),
    HasPets: accosBarData.value.pets.hasPets,
    PetsMessage: accosBarData.value.pets.message,

    Title: Title.Unknown,
    Firstname: null,
    Lastname: null,
    Email: null,
    Phone: null,
    Message: null
  }

  return encodeURIComponent(JSON.stringify(dto))
}
